import { render, staticRenderFns } from "./oblique.vue?vue&type=template&id=f51fabd4&scoped=true&"
import script from "./oblique.vue?vue&type=script&lang=js&"
export * from "./oblique.vue?vue&type=script&lang=js&"
import style0 from "./oblique.vue?vue&type=style&index=0&id=f51fabd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51fabd4",
  null
  
)

component.options.__file = "oblique.vue"
export default component.exports